import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  styled,
  useTheme,
  Paper,
} from "@mui/material";
import AddRoles from "./RolePermissions";
import {
  useGetAllLeadsRolesForTableQuery,
  useGetAllRolesForTableQuery,
} from "../../redux/api/rolesApi";
import { MuiTable } from "../../components/MuiTable";
import { ROLES_PERMISSION_COLUMNS, LEADS_PERMISSION_COLUMNS } from "./data";
import { selectCurrentagency } from "../../redux/features/authSlice";
import { useSelector } from "react-redux";
import LeadPermissions from "./LeadPermissions";
import { LEAD_PERMISSIONS } from "./permissions";

export default function RolesPage() {
  const [openRole, setOpenRole] = useState(false);
  const [openLead, setopenLead] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedLead, setSelectedLead] = useState(null);
  const currentAgency = useSelector(selectCurrentagency);
  const {
    data: rolesData,
    isLoading,
    refetch,
  } = useGetAllRolesForTableQuery({ agcId: currentAgency.agencyid });
  const {
    data: leadsData,
    isLoading: isLoadingLeads,
    refetch: refetchLeads,
  } = useGetAllLeadsRolesForTableQuery({ agcId: currentAgency.agencyid });
  const theme = useTheme();
  // Role Permissions
  const handleOpenRole = () => {
    setSelectedRole(null);
    setOpenRole(true);
  };

  const handleCloseRole = () => {
    setOpenRole(false);
    setSelectedRole(null);
  };

  const handleEditRole = (rowData) => {
    setSelectedRole(rowData);
    setOpenRole(true);
  };

  // Leads Permissions
  const handleOpenLead = () => {
    setSelectedLead(null);
    setopenLead(true);
  };

  const handleCloseLead = () => {
    setopenLead(false);
    setSelectedLead(null);
  };

  const handleEditLead = (rowData) => {
    setSelectedLead(rowData);
    setopenLead(true);
  };

  return (
    <Box sx={{ p: 3 }}>
      <StyledContainer>
        <Typography variant="h2">Role Permissions</Typography>
        <Box>
          <Button
            variant="contained"
            onClick={handleOpenRole}
            sx={{
              ml: "auto",
              color: "white",
              textTransform: "none",
              fontWeight: 500,
              px: 3,
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            }}
          >
            Assign New Role
          </Button>
        </Box>
      </StyledContainer>

      <Paper
        elevation={0}
        sx={{
          mt: 3,
          mb: 5,
          border: "none",
          borderRadius: 1,
          overflow: "hidden",
        }}
      >
        <MuiTable
          data={rolesData || []}
          isLoading={isLoading}
          columns={ROLES_PERMISSION_COLUMNS(handleEditRole)}
          enableColor={false}
          enableRowSelection={false}
          enableActionButton={false}
        />
      </Paper>

      <StyledContainer>
        <Typography variant="h2">Leads Permissions</Typography>
        <Box>
          <Button
            variant="contained"
            onClick={handleOpenLead}
            sx={{
              ml: "auto",
              color: "white",
              textTransform: "none",
              fontWeight: 500,
              px: 3,
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            }}
          >
            Assign Leads Permissions
          </Button>
        </Box>
      </StyledContainer>

      <Paper
        elevation={0}
        sx={{
          mt: 3,
          mb: 5,
          border: "none",
          borderRadius: 1,
          overflow: "hidden",
        }}
      >
        <MuiTable
          data={leadsData || []}
          isLoading={isLoadingLeads}
          columns={LEADS_PERMISSION_COLUMNS(handleEditLead)}
          enableColor={false}
          enableRowSelection={false}
          enableActionButton={false}
        />
      </Paper>

      <AddRoles
        open={openRole}
        onClose={handleCloseRole}
        selectedRole={selectedRole}
        refetch={refetch}
      />
      <LeadPermissions
        open={openLead}
        onClose={handleCloseLead}
        selectedLead={selectedLead}
        refetch={refetchLeads}
      />
    </Box>
  );
}

const StyledContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "center", // Center horizontally
    justifyContent: "center", // Center vertically (if applicable)
    textAlign: "center", // Optional: Center text content
    gap: theme.spacing(2),
  },
}));
